module.exports = __webpack_public_path__ + "static/media/resume.62efbc6f.pdf";